import { IConversionSource } from '../conversion-source/conversion-source.model';
import { IConversionDetail } from '../conversion/conversion.model';
import httpClient from "../http/http-client";

export default class ConversionFactorImportLineService {
  http;
  constructor() {
    this.http = httpClient
  }

  async getAll(queryParams?: string): Promise<any> {
    return this.http.get(`conversion-factor-import-line${queryParams ? queryParams : ''}`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        throw err
      });
  }

  async getAllWithPagination(page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc', queryParams?: string): Promise<{ count: number, rows: any[], conversionSource: IConversionSource, importFailed?: boolean }> {
    return this.http.get(`conversion-factor-import-line?page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}${queryParams ? queryParams : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async getLevelOnes(queryParams?: string): Promise<any> {
    return this.http.get(`conversion-factor-import-line/level-ones${queryParams ? queryParams : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async commitLines(data: any): Promise<void> {
    return this.http.post(`conversion-factor-import-line/commit`, data)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async discardLines(data: any): Promise<void> {
    return this.http.post(`conversion-factor-import-line/discard`, data)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async uploadMappings(data: any): Promise<any> {
    return this.http.post(`conversion-factor-import-line/upload-mappings`, data)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }


  async postCategoryMappings(data: any): Promise<void> {
    return this.http.post(`conversion-factor-import-line/level-one-category-mappings`, data)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }
}